export const FETCH_CONDITIONS_DATA   = 'FETCH_CONDITIONS_DATA';
export const SELECT_CATEGORY   = 'SELECT_CATEGORY';
export const FETCH_CONDITIONS_NAME_DATA   = 'FETCH_CONDITIONS_NAME_DATA';
export const FETCH_ALL_CONDITIONS_DATA = 'FETCH_ALL_CONDITIONS_DATA';
